// priority 1...10
// blocker
// emergency

export const PriorityPalePalette: any = {
    1: '#AFE7FA',
    2: '#AFE7FA',
    3: '#BFE0FF',
    4: '#BFE0FF',
    // 5: '#BED0FF',
    5: '#BDC3CC',   // experimental
    6: '#FFD9BA',
    7: '#FFC5B3',
    8: '#FFC5B3',
    9: '#FFC5B3',
    10: '#FFC5B3',
    50: '#F8B9B8',
    100: '#F8B9B8'
}


export const PriorityPaleBorderPalette: any = {

    1: '#A7DDEF',
    2: '#A7DDEF',
    3: '#AFD4F6',
    4: '#AFD4F6',
    // 5: '#AFC4F9',
    5: '#BDC3CC',   // experimental
    6: '#FDD0AB',
    7: '#F7BBA8',
    8: '#F7BBA8',
    9: '#F7BBA8',
    10: '#F7BBA8',
    50: '#EDAEAD',
    100: '#EDAEAD',

}